export function createObjeto() {
  return {
    ObjetoId: 0,
    Nombre: '',
    TablaEspecifica: ''
  };
}
